// extracted by mini-css-extract-plugin
module.exports = {"text":"CheckinInfoCardItem-module__text___9sjHe","clipboardButton":"CheckinInfoCardItem-module__clipboardButton___PpCDw"};